module.exports = __webpack_public_path__ + "img/yun-you.a7b4ce39.png";